
























import { Vue, Component } from "vue-property-decorator";

@Component
export default class NavigationMenu extends Vue {
  private closeMenu() {
    this.$emit("close");
  }

  public mounted() {
    document.addEventListener("click", this.closeMenu);
  }

  public destroyed() {
    document.removeEventListener("click", this.closeMenu);
  }
}
